import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_translation, s_info_circle } from '@fiverr-private/fit/icons';

import './style.scss';

export const TranslateIcon = () =>
    l_translation();

export const InfoIcon = () =>
    s_info_circle();

const LEAN_TRANSLATION_ICON = 'lean-translation-icon';

export const LeanTranslationIcon = ({
    isTranslating,
    isTranslated
}) => {
    if (isTranslating) {
        return <span className="lean-translation-icon-dots"/>;
    }

    if (isTranslated) {
        const classNameIconInfo = classNames(
            LEAN_TRANSLATION_ICON,
            'lean-translation-icon-s-info-circle'
        );

        return (
            <Icon size={10}
                className={classNameIconInfo}>
                <InfoIcon/>
            </Icon>
        );
    }

    const classNameIconTranslate = classNames(
        LEAN_TRANSLATION_ICON,
        'lean-translation-icon-l-translation'
    );

    return (
        <Icon className={classNameIconTranslate} size={16}>
            <TranslateIcon/>
        </Icon>
    );
};

LeanTranslationIcon.propTypes = {
    isTranslating: bool.isRequired,
    isTranslated: bool.isRequired
};

export default LeanTranslationIcon;
